// extracted by mini-css-extract-plugin
export default {"idnow2":"MRYzkh4+PsycvU6z6mT-uQ=="};